import React, { useMemo } from "react";

export default function StarField({ count = 120, className = "earth-overlay" }) {
    const stars = useMemo(
        () =>
            Array.from({ length: count }, (_, i) => ({
                id: i,
                x: Math.random() * 100,
                y: Math.random() * 100,
                size: Math.random() * 2 + 0.5,
                opacity: Math.random() * 0.8 + 0.2,
                delay: Math.random() * 3,
            })),
        [count]
    );

    return (
        <div className={className}>
            {stars.map((s) => (
                <div
                    key={s.id}
                    className="earth-particle"
                    style={{
                        left: `${s.x}%`,
                        top: `${s.y}%`,
                        width: `${s.size}px`,
                        height: `${s.size}px`,
                        background: "white",
                        opacity: s.opacity,
                        animation: `twinkle ${2 + s.delay}s ease-in-out infinite alternate`,
                    }}
                />
            ))}
        </div>
    );
}